import styled from 'styled-components';
import { FaTimes, FaEquals } from 'react-icons/fa';

export const Container = styled.div``;

export const Subtitle = styled.div`
  color: ${({ theme }) => theme.colors.base[500]};
  font-size: 1.6rem;
  font-weight: 400;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3rem;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.base[500]};
  font-size: 2.2rem;
  font-weight: 700;
`;

export const BottomRow = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 3.563rem;
`;

export const WrapperInput = styled.div`
  flex: 1;
`;

export const WrapperMath = styled.div`
  height: 3.3rem;
  width: 3.3rem;
  background: rgba(83, 154, 218, 0.4);
  margin: 0 1.7rem;
  margin-bottom: 1.6rem;
  border-radius: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MultiplyIcon = styled(FaTimes).attrs({
  color: '#539ada',
  size: 18,
})``;

export const EqualsIcon = styled(FaEquals).attrs({
  color: '#539ada',
  size: 18,
})``;

export const Label = styled.div`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.base[500]};
  line-height: 1.4rem;
  font-weight: 400;
  margin-bottom: 1.6rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

export const WrapperResult = styled.div`
  background-color: rgba(214, 171, 20, 0.15);
  width: 100%;
  height: 6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  font-weight: 400;
  color: #d6ab14;
  border-radius: 1rem;
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: flex-end;
`;
